import Home from '..';

export default Home;
